import { Component, OnDestroy, OnInit } from '@angular/core';
import { StepsControllerService } from '../../../../services/steps-controller.service';
import { AdminService } from '../../../../services/admin.service';

@Component({
  selector: 'app-step-changelogs',
  templateUrl: './step-changelogs.component.html',
  styleUrls: ['./step-changelogs.component.css']
})
export class StepChangelogsComponent implements OnInit, OnDestroy {
  public isLoaded = false;
  public changeLogs: any[];
  public stnID = null;
  public showLogs = false;
  errorMessage = false;

  constructor(private adminService: AdminService,
    private stepsControllerService: StepsControllerService) {
  }

  ngOnDestroy() {
    this.stnID = null;
    this.changeLogs = [];
  }

  ngOnInit() {
    this.isLoaded = false;
    this.stnID = null;
    this.changeLogs = [];
    this.showLogs = false;

    if (this.stepsControllerService.getCurrentStandard() !== null) {
      if (this.stepsControllerService.getCurrentStandard().id !== undefined) {
        this.stnID = this.stepsControllerService.getCurrentStandard().id;
      } else if (this.stepsControllerService.getTempParrentID() !== null) {
        this.stnID = this.stepsControllerService.getTempParrentID();
      }
    } else {
      if (this.stepsControllerService.getLogsID() !== null) {
        this.stnID = this.stepsControllerService.getLogsID();
      } else {
        this.changeLogs = [];
      }
    }

    // GET Получить список описаний изменений
    if (!this.stnID) {
      this.isLoaded = true;
      return;
    }

    this.adminService.getChangeLogs(this.stnID).subscribe(
      (res: any) => {
        this.errorMessage = false;
        if (res.status === 200) {
          this.changeLogs = res.body;

          if (this.changeLogs.length > 0) {
            this.showLogs = true;
          }

          this.isLoaded = true;
        }
      },
      () => {
        this.errorMessage = true;
        this.isLoaded = true;
      }
    );

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/step-changelogs/step-changelogs.component.ts